import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AccountDeletionConfirmationModalComponent } from './account-deletion-confirmation-modal/account-deletion-confirmation-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    AccountDeletionConfirmationModalComponent,
  ],
  exports: [AccountDeletionConfirmationModalComponent],
})
export class FeaturesAccountDeletionConfirmationModalModule {}
